import React from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Form,
} from "react-bootstrap";
import {
  FaEnvelope,
  FaPhoneAlt,
  FaMapMarkerAlt,
} from "react-icons/fa";

const galleryImages = [
  "https://images.unsplash.com/photo-1519741497674-611481863552?w=600",
  "https://images.unsplash.com/photo-1522673607200-164d1b6ce486?w=600",
  "https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=600",
  "https://images.unsplash.com/photo-1511285560929-80b456fea0bc?w=600",
  "https://images.unsplash.com/photo-1520854221256-17451cc331bf?w=600",
  "https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=600",
  "https://images.unsplash.com/photo-1469371670807-013ccf25f16a?w=600",
  "https://images.unsplash.com/photo-1511795409834-ef04bbd61622?w=600",
  "https://images.unsplash.com/photo-1507504031003-b417219a0fde?w=600",
];

export default function GallerySection() {
  return (
    <>
      {/* Gallery Section */}
      <section className="py-5 bg-light" style={{ marginTop: "80px" }}>
        <Container>
          <div className="text-center mb-5">
            <h2 className="fw-bold">Our Stunning Gallery</h2>
            <p className="text-muted">
              Explore beautiful wedding moments and venue decorations
            </p>
          </div>

          <Row className="g-4">
            {galleryImages.map((img, index) => (
              <Col lg={4} md={6} sm={6} xs={12} key={index}>
                <Card
                  className="border-0 shadow-sm overflow-hidden"
                  style={{
                    borderRadius: "16px",
                    cursor: "pointer",
                  }}
                >
                  <div style={{ overflow: "hidden" }}>
                    <Card.Img
                      src={img}
                      style={{
                        height: "280px",
                        objectFit: "cover",
                        transition: "transform 0.5s ease",
                      }}
                      className="gallery-img"
                    />
                  </div>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>

        <style>
          {`
            .gallery-img:hover {
              transform: scale(1.08);
            }
          `}
        </style>
      </section>

      {/* Contact Section */}
      <section style={{ background: "#FFFFFF", padding: "80px 0" }}>
        <Container>
          <Row>
            {/* Left Side */}
            <Col md={5} className="mb-4">
              <h2 className="fw-bold mb-3">Get in Touch</h2>
              <p className="text-muted mb-4">
                We'd love to hear from you! Reach out today.
              </p>

              <div className="mb-3 d-flex align-items-center">
                <FaEnvelope className="me-2" />
                <span>info@eternalvows.com</span>
              </div>

              <div className="mb-3 d-flex align-items-center">
                <FaPhoneAlt className="me-2" />
                <span>(555) 123-4567</span>
              </div>

              <div className="d-flex align-items-center">
                <FaMapMarkerAlt className="me-2" />
                <span>123 Wedding Lane, New York, NY 10001</span>
              </div>
            </Col>

            {/* Right Side Form */}
            <Col md={7}>
              <Form>
                <Form.Group className="mb-3">
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter your name"
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="Enter your email"
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Message</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={4}
                    placeholder="Type your message"
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Check
                    type="checkbox"
                    label="I accept the Terms"
                  />
                </Form.Group>

                <Button
                  style={{
                    background: "#ff3b1f",
                    border: "none",
                    padding: "10px 28px",
                  }}
                >
                  Submit
                </Button>
              </Form>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}